import React, { useState } from "react";
import UpperFooter from "./UpperFooter";
import LowerFooter from "./LowerFooter";
import MiddleFooter from "./MiddleFooter";
import "./Footer.css"
import MobileNavbar from "./MobileNavbar";
import { GET_MENU_LIST } from '../../GraphQL/Queries'
import { useQuery } from '@apollo/client'

const Footer = () => {
  const [menuData, setMenuData] = useState([]);
  const [name, setName] = useState("");

  const { loading } = useQuery(GET_MENU_LIST, {
    variables: {
      first: 100,
      channel: "default-channel"
    },
    onCompleted: (data) => {
      // Safe access to deeply nested data
      const items = data?.menus?.edges?.[0]?.node?.items || [];
      const menuName = data?.menus?.edges?.[0]?.node?.name || "Menu";
      setMenuData(items);
      setName(menuName);
    },
  });

  return (
    <footer>
      <div className="footer">
        {/* Instead of deleting, just hide it via CSS to keep the DOM structure */}
        <div style={{ display: 'none' }}>
          <UpperFooter />
        </div>
        <div style={{ maxWidth: "95%" }} className="container">
          <MiddleFooter />
          <div className="mb-3">
            <div className="col gu12 _3MmGvF">
              <div className="_1GTrm1">
                <span className="_2oyLgr">{name}:</span>
                {/* Safe mapping: check if menuData exists first */}
                {menuData?.map((value, index) => (
                  <a key={index} className="_3CuAg8" href={value.url}>
                    {value.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <LowerFooter />
        </div>
      </div>
      <div className="mobileMenuOverlays"></div>
      <MobileNavbar />
    </footer>
  );
};


export default Footer;
